import { Injectable } from "@angular/core";
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";

import { Observable } from "rxjs";

import { AuthorizationService } from "../services/authorization.service";
import { AnalyticsPagePath, ConfigService, TokenService } from "common";
import { JwtHelperService } from "@auth0/angular-jwt";

@Injectable()
export class AuthorizationGuard  {
  private marketingPage: string[] = [AnalyticsPagePath.B2CDashboardPath, AnalyticsPagePath.B2CPlanEstimatorPath,
  AnalyticsPagePath.B2CFaqPath, AnalyticsPagePath.B2CContactUsPath, AnalyticsPagePath.B2CPricingPath, AnalyticsPagePath.B2CCoveragePath, AnalyticsPagePath.B2CConfirmationPath]
  constructor(
    private _router: Router,
    private authorizationService: AuthorizationService,
    private configService: ConfigService,
    private tokenService: TokenService
  ) { }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    if (this.configService.getEnableClientAULLogin && this.configService.getEnableClientAULLogin == 'true') {
      return this.authorizationService.canActivate(state.url, this._router, route);
    }
    else {
      const token = this.tokenService.getAccessToken();
      if (!token || new JwtHelperService().isTokenExpired(token.accessToken)) {
        if (state.url.trim() == '') {
          return this.tokenService.returnToken().toPromise();
        }
        const isMarketingPages = this.marketingPage.some(x => x.toLocaleLowerCase().trim() == state.url.toLocaleLowerCase().trim());
        if (isMarketingPages || state.url == '/') {
          return this.tokenService.returnToken().toPromise();
        } else {
          const sp = AnalyticsPagePath.B2CDashboardPath;
          this._router.navigate([sp]);
        }
      } else {
        return true;
      }
      return true;
    }

  }
}
